import React, {useEffect} from "react"
import {useDispatch, useSelector} from "react-redux"
import {useParams} from "react-router-dom"
import GoBack from "../subsidiary/GoBack/GoBack"
import Loader from "../subsidiary/Loader/Loader"
import styles from "./Event.module.css"
import moment from 'moment'
import 'moment/locale/ru'
import {fetchEvent} from "../Calendar/calendarSlice"

const Event = () => {

    const id = useParams().id
    const dispatch = useDispatch()
    const event = useSelector(state => state.calendarSlice.event)
    const isLoaded = useSelector(state => state.calendarSlice.eventLoaded)
    const error = useSelector(state => state.calendarSlice.error)
    
    const formatDateDisplay = () => {
        // Check if event object exists and has data
        if (!event || Object.keys(event).length === 0) {
            return 'Дата не указана'
        }
        
        if (event.start_time) {
            const hasEndTime = event.end_time && event.end_time !== event.start_time
            if (hasEndTime) {
                return `c ${moment(event.start_time).format('DD MMM YYYY')} по ${moment(event.end_time).format('DD MMM YYYY')}`
            }
            return moment(event.start_time).format('DD MMMM YYYY')
        }
        
        // Fallback to created_at if start_time not available
        if (event.created_at) {
            return moment(event.created_at).format('DD MMM YYYY')
        }
        
        return 'Дата не указана'
    }
    
    const date = formatDateDisplay()

    useEffect(() => {
        console.log(`Loading event ${id}`)
        dispatch(fetchEvent({id}))
    }, [id, dispatch])

    useEffect(() => {
        if (error.failed) {
            console.error(`Error loading event ${id}:`, error.message)
        }
        if (isLoaded && event && Object.keys(event).length > 0) {
            console.log(`Event ${id} loaded:`, event)
        }
    }, [error, isLoaded, event, id])

    if (error.failed) {
        return (
            <div className="content-wrapper">
                <section className={styles.news + ' main'}>
                    <div className={styles.wrapper}>
                        <div style={{padding: '30px', textAlign: 'center'}}>
                            <h1>Событие не найдено</h1>
                            <p>Событие с ID {id} не найдено или произошла ошибка при загрузке.</p>
                            <p style={{color: '#999', fontSize: '14px'}}>{error.message || 'Неизвестная ошибка'}</p>
                        </div>
                    </div>
                </section>
            </div>
        )
    }

    return (
        <>
            {isLoaded && event && Object.keys(event).length > 0 ?
                <div className="content-wrapper">
                    <section className={styles.news + ' main'}>
                        <div className={styles.wrapper}>
                            <GoBack text={date}/>
                            <div className={styles.img} style={{
                                background: `${event.media?.image ? `linear-gradient(0deg, rgba(0, 0, 0, 0.38), rgba(0, 0, 0, 0.38)), url(${event.media.image})` : 'black'}`,
                                backgroundSize: 'cover'
                            }}>
                                <div style={{padding: '30px'}}>
                                    <h1 className={styles.title}>
                                        {event.name}
                                    </h1>
                                    <div className={styles.tags}>
                                        {/* {data.tags.map(tag => {
                                            return <span className={styles.tag}>{tag.text}</span>
                                        })
                                        } */}
                                    </div>
                                </div>
                            </div>
                            <div className="content-wrapper">
                                {event.text ?
                                    <div dangerouslySetInnerHTML={{__html: event.text}} className={styles.textContent}>
                                    </div> : <div>Текста нет</div>}
                            </div>
                        </div>
                    </section>
                </div> : <Loader/>}
        </>
    )
}
export default Event
